module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/kettle-0ef2e5b1461eb37ef8fcdcfffaaf8575.svg";